import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreDtwinStateTableSourceIcon',
  props: {
    item: {
      type: Object,
      required: true
    },
    showName: {
      type: Boolean,
      required: false,
      default: false
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    icon: function icon() {
      return this.metaObj.icon;
    },
    image: function image() {
      return this.metaObj.image;
    },
    name: function name() {
      return this.metaObj.name || this.metaObj.title;
    },
    metaObj: function metaObj() {
      var _this = this;

      if (this.item.properties.binding.type === 'bridge') {
        var config = this.bridgeConfigs.find(function (c) {
          return parseInt(c.configId) === parseInt(_this.item.properties.binding.options.configId);
        });

        if (config) {
          return config;
        }
      }

      return this.dataSources.find(function (d) {
        return d.type === _this.item.properties.binding.type;
      }) || {};
    }
  }
};